import type { PapelUsuario } from '@pgcustom/shared-types';

export interface PermissoesAuditoria {
  ler: boolean;
}

/** Espelho do RBAC real: `GET /api/v1/auditoria` exige recurso `auth`, só concedido a `admin` (nenhuma migration seeda `auth` para outro papel). */
export function permissoesAuditoria(papel: PapelUsuario): PermissoesAuditoria {
  return { ler: papel === 'admin' };
}
